import { render } from "./CameraName.vue?vue&type=template&id=b03c6a48&ts=true"
import script from "./CameraName.vue?vue&type=script&lang=ts"
export * from "./CameraName.vue?vue&type=script&lang=ts"

import "./CameraName.vue?vue&type=style&index=0&id=b03c6a48&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__